import { render, staticRenderFns } from "./ClinicHistory.vue?vue&type=template&id=bc67eaaa"
import script from "./ClinicHistory.vue?vue&type=script&lang=js"
export * from "./ClinicHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports